/**
 * Online API
 * # Summary Elisa B2B Online API written in golang hosted in AWS cloud  # Usage This API is used in the `https://yrityksille.elisa.fi/` pages.  # Identifiers 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Possible actions on an asset type.
 */
export type AssetCapabilityAction = 'CREATE' | 'READ' | 'UPDATE' | 'DELETE';

export const AssetCapabilityAction = {
    CREATE: 'CREATE' as AssetCapabilityAction,
    READ: 'READ' as AssetCapabilityAction,
    UPDATE: 'UPDATE' as AssetCapabilityAction,
    DELETE: 'DELETE' as AssetCapabilityAction
};

